import {Content} from "#/src/pages/(legal)/regulamin/Content";

export {Page}

function Page() {
  return <div className={"h-100"}><Content/></div>
}
